import React, { useEffect, useState } from 'react'
import {
  Modal, Row, Col, Button,
} from 'antd'

import __ from '../../languages/parser'

const ModalSaveComposition = ({
  visible, hide, compositionId,
}) => {
  const [isQueryOk, setIsQueryOk] = useState(false)

  const copyClipboard = (txt) => {
    navigator.clipboard.writeText(txt)
      .then(
        () => {
          console.log('copy OK')
        }, () => {
          console.log('impossible to copy')
        },
      )
  }

  const copyId = () => {
    copyClipboard(compositionId)
  }


  const getFormatedUrl = () => (`${document.location.origin + document.location.pathname}?model=${compositionId}`)

  const mailSubject = `${__('My Gassien Composition')}%20${compositionId}`
  const mailBody = `${__('Have a look to my Gassien composition:')}%20${getFormatedUrl()}`
  const footer = '%0D%0A%0D%0Awww.gassien.com'

  const sharedEmail = `mailto:?subject=${mailSubject}&body=${mailBody}${footer}`

  const checkIsQueryOk = () => {
    if (navigator && navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
        if (result.state === 'granted' || result.state === 'prompt') {
          setIsQueryOk(true)
        } else {
          setIsQueryOk(false)
        }
      })
    } else {
      setIsQueryOk(false)
    }
  }

  useEffect(() => {
    checkIsQueryOk()
  }, [])

  return (
    <Modal
      title="Composition"
      visible={visible}
      onOk={hide}
      onCancel={hide}
      zIndex={99999}
      footer={[
        null,
        <Button key="submit" type="primary" onClick={hide}>
          OK
        </Button>,
      ]}
    >
      <Row style={{ textAlign: 'center', marginBottom: '1em' }}>
        <Col span={24}>
          {__('Your composition number is:')}
        </Col>
      </Row>
      <Row>
        <Col offset={3} span={18} style={{ textAlign: 'center' }}>
          <pre style={{
            fontSize: '1.6em',
            backgroundColor: 'lightgrey',
            letterSpacing: '0.4em',
            textAlign: 'center',
            padding: '0.4em 0',
          }}
          >
            {compositionId}
          </pre>
        </Col>
      </Row>
      <Row justify="space-around">
        {isQueryOk
          ? (
            <Col span={8}>
              <Button block onClick={copyId}>{__('Copy')}</Button>
            </Col>
          )
          : null}
        <Col span={8}>
          <Button block href={sharedEmail}>{__('Share')}</Button>
        </Col>
      </Row>
      <Row style={{ marginTop: '1em', textAlign: 'center' }}>
        <Col span={24}>
          {__('You can keep it to retrieve at any time your composition')}
        </Col>
      </Row>
      <Row style={{ marginTop: '1em', textAlign: 'center' }}>
        <Col span={24}>
          <a
            href={`mailto:contact@gassien.com?subject=Maker infos&body=Infos Composition Number: ${compositionId}`}
            style={{ textDecoration: 'underline' }}
          >
            {__('You can contact us (contact@gassien.com) with this id for specific needs')}
          </a>
        </Col>
      </Row>

    </Modal>
  )
}

export default ModalSaveComposition
